import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

export default function DeleteFilePopUp(props) {
  const { isEmailPopUp, openConfirmationDialog, deletedRegisteredFile } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  function closeDeleteFilePopUp() {
    props.closePopUp(false);
  }

  function confirmDelete() {
    props.confirmDelete();
  }
  return (
    <Dialog
      open={!isEmailPopUp && openConfirmationDialog}
      onClose={closeDeleteFilePopUp}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <WarningIcon className={classes.warningIcon} fontSize="large" />
        </Grid>
        <Grid item xs={11}>
          <DialogTitle className={classes.dialogTitle}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.title}>
                  {t('Delete registered file')}
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={closeDeleteFilePopUp}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.dialogText}>
              {t('Are you sure you want to delete')} {deletedRegisteredFile}
              {t('from registered files')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              className={classes.cancelButton}
              onClick={closeDeleteFilePopUp}
              color="secondary"
              variant="outlined"
            >
              {t('Cancel')}
            </Button>
            <Button
              className={classes.validateButton}
              onClick={confirmDelete}
              color="secondary"
              variant="contained"
              autoFocus
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
